import React from 'react';

import { useIntl } from 'react-intl';

// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Box } from '@atlaskit/primitives/box';
// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Pressable } from '@atlaskit/primitives/pressable';
// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { xcss } from '@atlaskit/primitives/xcss/xcss';
import { components } from '@atlaskit/react-select/components';
import { token } from '@atlaskit/tokens';

import { i18n } from './messages';

const clearFilterOptionsButtonStyles = xcss({
	background: token('color.background.input'),
	color: 'color.text.subtle',
	border: 'none',
	paddingLeft: 'space.250',
	font: 'inherit',
	cursor: 'pointer',
	outline: 'inherit',
	display: 'flex',
	justifyContent: 'flex-start',
	alignItems: 'center',
	height: '36px',
	width: '100%',

	':hover': {
		backgroundColor: 'color.background.input.hovered',
	},

	':disabled': {
		// eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage -- the rule does not yet recognise @atlaskit/primitives subpath entry points
		color: 'color.text.accent.gray',
		cursor: 'default',
	},
});

type ClearFilterOptionsButtonProps = {
	children: string;
	disabled: boolean;
	onClick: () => void;
};

const ClearFilterOptionsButton = ({
	disabled,
	onClick,
	children,
}: ClearFilterOptionsButtonProps) => {
	return (
		<Pressable onClick={onClick} xcss={clearFilterOptionsButtonStyles} isDisabled={disabled}>
			{children}
		</Pressable>
	);
};

const menuFooterStyles = xcss({
	borderTop: `${token('color.border')} solid ${token('border.width')}`,
});

export const MenuList = (props: any): React.JSX.Element => {
	const { formatMessage } = useIntl();

	return (
		<>
			<components.MenuList {...props} />
			<Box xcss={menuFooterStyles}>
				{props.selectProps.canClearFilter && (
					<ClearFilterOptionsButton
						disabled={props.selectProps.clearOptionsDisabled}
						onClick={() => props.selectProps.onClearOptions()}
					>
						{formatMessage(i18n.searchClearFilterLabel)}
					</ClearFilterOptionsButton>
				)}
			</Box>
		</>
	);
};
